<!-- Loader -->
<div *ngIf="isLoading" class="flex h-[360px] w-full flex-col items-center justify-center gap-4">
  <div class="h-9 w-9 animate-spin rounded-full border-4 border-gray-200 border-t-gray-800"></div>
  <span class="text-sm font-medium text-gray-400">
    Heatmap
  </span>
</div>

<!-- TikTok Message -->
<ng-container *ngIf="pages?.[0]?.platform?.toLowerCase().includes('tiktok'); else notTiktokHeatmap">
  <div class="w-full grid place-items-center">
    <div class="w-full max-w-6xl rounded-3xl border border-gray-200 bg-white p-5 shadow-sm">
      <div class="flex h-[360px] w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-6 text-center">
        <div>
          <p class="mb-1 text-sm font-semibold text-gray-500">
            TikTok analytics are not available yet.
          </p>
          <p class="text-xs text-gray-400">
            We're working on bringing you TikTok insights soon.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Non-TikTok Content -->
<ng-template #notTiktokHeatmap>
  <div *ngIf="!isLoading" class="w-full grid place-items-center">
    <div class="w-full max-w-6xl rounded-3xl border border-gray-200 bg-white p-5 shadow-sm">

      <!-- Header -->
      <div class="mb-4 text-center">
        <h2 class="text-lg font-semibold tracking-tight text-gray-900 lg:text-xl">
          {{ title }}
        </h2>
      </div>

      <!-- Chart Container -->
      <div class="relative w-full">

        <!-- Chart -->
        <div class="grid w-full">
          <apx-chart
            #chartRef
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [dataLabels]="chartOptions.dataLabels"
            [plotOptions]="chartOptions.plotOptions"
            [colors]="chartOptions.colors"
            [xaxis]="chartOptions.xaxis"
            [yaxis]="chartOptions.yaxis"
            [tooltip]="chartOptions.tooltip"
            [legend]="chartOptions.legend"
            class="w-full"
          >
          </apx-chart>
        </div>

        <!-- Mobile helper -->
        <p *ngIf="isMobile" class="mt-2 text-center text-xs text-gray-400">
          Rows: Mon → Sun &nbsp;|&nbsp; Columns: 00h → 23h
        </p>

        <!-- No data overlay -->
        <div
          *ngIf="!hasData"
          class="absolute inset-0 flex items-center justify-center rounded-2xl bg-white/80 backdrop-blur-sm"
        >
          <span class="text-sm font-medium text-gray-500">
            No data available
          </span>
        </div>

        <!-- Legend -->
        <div *ngIf="legendLevels.length" class="mt-4 flex justify-end">
          <div class="flex items-center gap-1 text-xs text-gray-500">
            <span class="pr-2">No Posts</span>

            <span
              *ngFor="let lvl of legendLevels"
              class="h-3 w-3 rounded-sm"
              [style.background]="lvl.color"
            >
            </span>

            <span class="pl-2">High Eng.</span>
          </div>
        </div>

      </div>

    </div>
  </div>
</ng-template>